/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkMyTaskTabDto } from '../models/work-my-task-tab-dto';
import { WorkMyTodoGroupEnum } from '../models/work-my-todo-group-enum';
import { WorkMyTodosResultDto } from '../models/work-my-todos-result-dto';

@Injectable({ providedIn: 'root' })
export class WorkMyTodosV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `myTodosV2ControllerFindTabs()` */
  static readonly MyTodosV2ControllerFindTabsPath = '/v2/my-todos/tabs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myTodosV2ControllerFindTabs()` instead.
   *
   * This method doesn't expect any request body.
   */
  myTodosV2ControllerFindTabs$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkMyTaskTabDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyTodosV2Service.MyTodosV2ControllerFindTabsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkMyTaskTabDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myTodosV2ControllerFindTabs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myTodosV2ControllerFindTabs(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkMyTaskTabDto>> {
    return this.myTodosV2ControllerFindTabs$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkMyTaskTabDto>>): Array<WorkMyTaskTabDto> => r.body)
    );
  }

  /** Path part for operation `myTodosV2ControllerFindItems()` */
  static readonly MyTodosV2ControllerFindItemsPath = '/v2/my-todos/items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `myTodosV2ControllerFindItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  myTodosV2ControllerFindItems$Response(
    params?: {
      tabKey?: string;
      search?: string;
      includeNotInFocus?: boolean;
      group?: WorkMyTodoGroupEnum;
      offset?: number;
      limit?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMyTodosResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMyTodosV2Service.MyTodosV2ControllerFindItemsPath, 'get');
    if (params) {
      rb.query('tabKey', params.tabKey, {});
      rb.query('search', params.search, {});
      rb.query('includeNotInFocus', params.includeNotInFocus, {});
      rb.query('group', params.group, {});
      rb.query('offset', params.offset, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMyTodosResultDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `myTodosV2ControllerFindItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  myTodosV2ControllerFindItems(
    params?: {
      tabKey?: string;
      search?: string;
      includeNotInFocus?: boolean;
      group?: WorkMyTodoGroupEnum;
      offset?: number;
      limit?: number;
    },
    context?: HttpContext
  ): Observable<WorkMyTodosResultDto> {
    return this.myTodosV2ControllerFindItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMyTodosResultDto>): WorkMyTodosResultDto => r.body)
    );
  }

}
